export enum AllowedSharingPolicy {
  NO_POLICY = "no-policy",
  ALL = "all",
  COMPANY_ONLY = "company",
  COMPANIES_OF_CORPORATE = "corporate",
}
